/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Search_LabelInputs */

const en_directory_search_label = /** @type {(inputs: Directory_Search_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search AI tools`)
};

const zh_directory_search_label = /** @type {(inputs: Directory_Search_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索 AI 工具`)
};

/**
* | output |
* | --- |
* | "Search AI tools" |
*
* @param {Directory_Search_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_search_label = /** @type {((inputs?: Directory_Search_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Search_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_search_label(inputs)
	return zh_directory_search_label(inputs)
});
export { directory_search_label as "directory.search.label" }